import React, { useEffect, useRef } from 'react';

const BackgroundVideos = ({ characterStyle, onVideoEnd, onVideoLoaded }) => {
  const videoRef = useRef(null);
  const videoSources = [
    `/videos/${characterStyle}/special1.mp4`,
    `/videos/${characterStyle}/special2.mp4`,
  ];

  useEffect(() => {
    const videoElement = videoRef.current;

    const handleEnded = () => {
      onVideoEnd();
    };

    const handleLoadedData = () => {
      onVideoLoaded();
    };

    if (videoElement) {
      videoElement.addEventListener('ended', handleEnded);
      videoElement.addEventListener('loadeddata', handleLoadedData);
      videoElement.play().catch((error) => {
        console.error('Error playing video:', error);
      });
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener('ended', handleEnded);
        videoElement.removeEventListener('loadeddata', handleLoadedData);
      }
    };
  }, [onVideoEnd, onVideoLoaded]);

  return (
    <div className="background-video-container">
      <video ref={videoRef} className="background-video" loop={false} autoPlay muted preload="auto">
        {videoSources.map((src, index) => (
          <source key={index} src={src} type="video/mp4" />
        ))}
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default BackgroundVideos;
